import { render, staticRenderFns } from "./xueqing.vue?vue&type=template&id=4a38f47e&scoped=true&"
import script from "./xueqing.vue?vue&type=script&lang=js&"
export * from "./xueqing.vue?vue&type=script&lang=js&"
import style0 from "./xueqing.vue?vue&type=style&index=0&id=4a38f47e&prod&lang=scss&"
import style1 from "./xueqing.vue?vue&type=style&index=1&id=4a38f47e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38f47e",
  null
  
)

export default component.exports